import React from 'react';
import styled from 'styled-components';

import Icon from '../kingpin/atoms/Icon';

const Banner = styled.div<{ isShort?: boolean }>`
  border-radius: 4px;
  background-color: var(--color-avatar-2-bg);
  padding: ${(props) => (props.isShort ? '12px 32px' : '24px 16px')};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: ${(props) => (props.isShort ? 'center' : 'flex-start')};
`;

const InfoBanner = ({
  children,
  isShort,
  hideIcon,
}: {
  children: JSX.Element | JSX.Element[];
  isShort?: boolean;
  hideIcon?: boolean;
}) => (
  <Banner isShort={isShort}>
    {!hideIcon && (
      <div style={{ marginRight: 8, display: 'flex' }}>
        <Icon icon="info" />
      </div>
    )}
    <div style={{ display: 'flex' }}>{children}</div>
  </Banner>
);

export default InfoBanner;
